export default ({ app }) => {
  app.nuxtServerInit = async (context) => {
    const userAgent = context.req.headers['user-agent']
    // Store or utilize userAgent information on the server-side
    console.log('User agent:', userAgent)
  }
}
